// extracted by mini-css-extract-plugin
export default {"form":"AddProject_form__w9zBu","spacing":"AddProject_spacing__7Lse9","select":"AddProject_select__HJ7k1"};